import { isPlatformServer, Location } from '@angular/common';
import {
  Component,
  Inject,
  OnInit,
  Optional,
  PLATFORM_ID,
} from '@angular/core';
import { RESPONSE } from '@nguniversal/express-engine/tokens';
import { Response } from 'express';
import { BreakpointWidthEnum } from '~/core/enums/breakpoint-width.enum';
import { ErrorCodeService } from '~/core/services/error-code/error-code.service';
import { ErrorCodesEnum } from '~/core/services/error-code/enums/codes.enum';
import { ParamethorService } from '~/paramethor/paramethor.service';
import { VtmnPlayButtonShapeEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-shape.enum';
import { VtmnPlayButtonVariantEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-variant.enum';
import { VtmnPlayButtonVariantStyleEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-variant-style.enum';
import { VtmnPlayIconTypeEnum } from '~/component/vtmn-play-icon/enums/vtmn-play-icon-type.enum';
import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
})
export class NotFoundComponent implements OnInit {
  public readonly mdScreenSize = `(min-width:${BreakpointWidthEnum.MD}px)`;
  public readonly notFoundIcon = VtmnPlayIconTypeEnum.EmotionUnhappy;
  public readonly vtmnPlayButtonVariant = VtmnPlayButtonVariantEnum;
  public readonly vtmnPlayButtonStyle = VtmnPlayButtonVariantStyleEnum;
  public readonly vtmnPlayButtonShape = VtmnPlayButtonShapeEnum;

  public errorCode = ErrorCodesEnum.No;

  constructor(
    @Inject(PLATFORM_ID) private readonly platformId: string,
    @Optional() @Inject(RESPONSE) private readonly response: Response,
    private readonly errorCodeService: ErrorCodeService,
    protected readonly paramethorService: ParamethorService,
    public readonly location: Location,
    private readonly metaService: Meta
  ) {}

  public ngOnInit(): void {
    this.errorCode = this.errorCodeService.getCurrentCode();
    if (isPlatformServer(this.platformId)) {
      this.response.status(404);
      this.metaService.addTag({ name: 'robots', content: 'noindex' });
    }
  }
}
